import WorkSans400 from 'src/assets/fonts/worksans-regular-webfont.woff2';
import WorkSans500 from 'src/assets/fonts/worksans-medium-webfont.woff2';
import WorkSans700 from 'src/assets/fonts/worksans-bold-webfont.woff2';

import Montserrat400 from 'src/assets/fonts/montserrat-regular.woff2';
import Montserrat500 from 'src/assets/fonts/montserrat-medium.woff2';
import Montserrat700 from 'src/assets/fonts/montserrat-bold.woff2';

import Inter400 from 'src/assets/fonts/inter-regular.woff2';
import Inter500 from 'src/assets/fonts/inter-medium.woff2';
import Inter600 from 'src/assets/fonts/inter-semibold.woff2';
import Inter700 from 'src/assets/fonts/inter-bold.woff2';

interface FontOptionsType {
    name: string;
    format: 'woff2';
    fonts: Array<{
        weight: number;
        path: string;
    }>;
}

const fontsDefault: Array<FontOptionsType> = [
    {
        name: 'Montserrat',
        format: 'woff2',
        fonts: [
            {
                weight: 400, // Regular
                path: Montserrat400,
            },
            {
                weight: 500, // Medium
                path: Montserrat500,
            },
            {
                weight: 700, // Bold
                path: Montserrat700,
            },
        ],
    },
    {
        name: 'Work Sans',
        format: 'woff2',
        fonts: [
            {
                weight: 400, // Regular
                path: WorkSans400,
            },
            {
                weight: 500, // Medium
                path: WorkSans500,
            },
            {
                weight: 700, // Bold
                path: WorkSans700,
            },
        ],
    },
    {
        name: 'Inter',
        format: 'woff2',
        fonts: [
            {
                weight: 400, // Regular
                path: Inter400,
            },
            {
                weight: 500, // Medium
                path: Inter500,
            },
            {
                weight: 600, // Semi Bold
                path: Inter600,
            },
            {
                weight: 700, // Bold
                path: Inter700,
            },
        ],
    },
];

export const generateFontFace = (): string => {
    const optionsListResult: Array<string> = [];

    for (const options of fontsDefault) {
        const { name, fonts, format } = options;

        for (const font of fonts) {
            optionsListResult.push(`
                @font-face {
                    font-family: '${name}';
                    font-weight: ${font.weight};
                    font-style: normal;
                    src: url('${font.path}') format('${format}');
                    font-display: swap;
                }
            `);
        }
    }

    return optionsListResult.join('');
};
